const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    invisibleButton: {
      position: 'relative',
      width: 'fit-content',
      height: 'fit-content',
      padding: 0,
      background: 'transparent',
      border: 'none',
      textAlign: 'initial',
    },
    cardContainer: {
      // border: '2px transparent solid',
    },
    insuranceSelected: {
      border: '1px #FF2CBF solid',
      borderRadius: '2px',
      '&:after': {
        display: 'block',
        borderRadius: '100%',
        content: 'url(icon/GameRoomItem/insuranceTick.svg)',
        color: '#FFFFFF',
        fontSize: '8px',
        height: '12px',
        left: 0,
        position: 'absolute',
        bottom: 1,
        width: '12px',
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
